const initialiseDataLayer = () => {
  window.dataLayer = window.dataLayer || [];
};

export const gaMFAEnabled = () => {
  initialiseDataLayer();

  window.dataLayer.push({
    event: 'MFAEnabled',
  });
};

export const gaMFADisabled = () => {
  initialiseDataLayer();

  window.dataLayer.push({
    event: 'MFADisabled',
  });
};

export const gaMobileNumberUpdated = () => {
  initialiseDataLayer();

  window.dataLayer.push({
    event: 'mobileNumberUpdated',
  });
};

export const gaMFAError = error => {
  initialiseDataLayer();

  window.dataLayer.push({
    event: 'Error',
    error_code: Object.keys(error)[0],
    errorMessage: Object.values(error)[0],
  });
};
